// NOTE: REACT_APP_ADMIN_EMAILS overrides this list entirely when set, and it is
// set in every deployed environment from the EVENT_PLANNER_ADMIN_EMAILS secret
// (see cloudbuild.yaml). Adding someone here alone will NOT make them an admin
// in production — the secret has to be updated too.
const DEFAULT_ADMIN_EMAILS = [
  'prakash@nativeorange.ai',
  'srinivase@nativeorange.ai',
  'venkat@nativeorange.ai'
];

// Employees who get the Links Viewer app without being full admins
const DEFAULT_LINKS_VIEWER_EMAILS = [
  'nutank@nativeorange.ai',
  'sameerk@nativeorange.ai',
  'venkat@nativeorange.ai'
];

// Of those, who can also add and edit links (still not delete — admins only).
// Keep in sync with LINKS_EDITOR_EMAILS in api/server.js, which is what actually
// enforces this; the checks here only decide what UI is shown.
const DEFAULT_LINKS_EDITOR_EMAILS = [
  'nutank@nativeorange.ai',
  'sameerk@nativeorange.ai'
];

// Who can see the Team Games page. Deliberately a standalone allowlist rather
// than a role check — only these exact addresses get it, even other admins.
const DEFAULT_TEAM_GAMES_EMAILS = [
  'srinivase@nativeorange.ai'
];

function parseEmailList(raw, fallback) {
  return (raw || fallback.join(','))
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
}

const ADMIN_EMAILS = parseEmailList(process.env.REACT_APP_ADMIN_EMAILS, DEFAULT_ADMIN_EMAILS);

const LINKS_VIEWER_EMAILS = parseEmailList(
  process.env.REACT_APP_LINKS_VIEWER_EMAILS,
  DEFAULT_LINKS_VIEWER_EMAILS
);

const LINKS_EDITOR_EMAILS = parseEmailList(
  process.env.REACT_APP_LINKS_EDITOR_EMAILS,
  DEFAULT_LINKS_EDITOR_EMAILS
);

const TEAM_GAMES_EMAILS = parseEmailList(
  process.env.REACT_APP_TEAM_GAMES_EMAILS,
  DEFAULT_TEAM_GAMES_EMAILS
);

export const COMPANY_DOMAIN = 'nativeorange.ai';

export function isNativeorangeEmail(email = '') {
  return email.toLowerCase().endsWith(`@${COMPANY_DOMAIN}`);
}

export function getUserRole(email = '') {
  const normalized = email.toLowerCase();
  if (ADMIN_EMAILS.includes(normalized)) return 'admin';
  return 'employee';
}

export function canAccessApp(email = '') {
  return isNativeorangeEmail(email);
}

// Admins always have it; specific employees can be granted it by email.
// Being an editor implies access, so a one-sided config change can't lock someone out.
export function canAccessLinksViewer(email = '') {
  const normalized = email.toLowerCase();
  return ADMIN_EMAILS.includes(normalized)
    || LINKS_VIEWER_EMAILS.includes(normalized)
    || LINKS_EDITOR_EMAILS.includes(normalized);
}

// Add and edit links. Deleting stays admin-only (see canDeleteLinks).
export function canManageLinks(email = '') {
  const normalized = email.toLowerCase();
  return ADMIN_EMAILS.includes(normalized) || LINKS_EDITOR_EMAILS.includes(normalized);
}

export function canDeleteLinks(email = '') {
  return ADMIN_EMAILS.includes(email.toLowerCase());
}

// Team Games is restricted to an explicit allowlist (not the admin role), so
// it stays hidden for everyone else — including other admins.
export function canAccessTeamGames(email = '') {
  return TEAM_GAMES_EMAILS.includes(email.toLowerCase());
}
